import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMisBatchPage } from '@/features/pcmp/pages/PcmpMisBatchPage';
import { pcmpMisBatchSearchSchema } from '@/features/pcmp/types/pcmpMis.types';

export const Route = createFileRoute('/_auth/pcmp/mis/batches/$batchNo/')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpMisBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MIS Batch">
      <Suspense fallback={<PageLoader />}>
        <PcmpMisBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
